export default function () {
  blockLibrary()
  return true
}

function blockLibrary() {
  return createStylesTag(
    '/wp-includes/css/dist/block-library/style.min.css?ver=5.4.2'
  )
}

function createStylesTag(url) {
  const styleCSS = document.createElement('link')
  const firstElement =
    document.head.childNodes[document.head.childNodes.length - 1]

  styleCSS.rel = 'stylesheet'
  styleCSS.href = url

  document.head.insertBefore(styleCSS, firstElement.nextSibling)

  return styleCSS
}
